(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["luxisy-trust-points"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateDates = (root) => {
      const targets = root.querySelectorAll('[data-luxisy-delivery-date]');
      if (!targets.length) return;

      const madrid = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit'
      });
      const parts = Object.fromEntries(madrid.formatToParts(new Date()).map((part) => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
      const addBusinessDays = (count) => {
        const date = new Date(today);
        let added = 0;
        while (added < count) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) added += 1;
        }
        return date;
      };
      const from = addBusinessDays(9);
      const to = addBusinessDays(15);
      const month = (date) => new Intl.DateTimeFormat('es-ES', { month: 'long', timeZone: 'UTC' }).format(date);
      const dayMonth = (date) => `${date.getUTCDate()} de ${month(date)}`;
      const label = from.getUTCMonth() === to.getUTCMonth()
        ? `Entre el ${from.getUTCDate()} y el ${to.getUTCDate()} de ${month(to)}`
        : `Entre el ${dayMonth(from)} y el ${dayMonth(to)}`;
      targets.forEach((target) => { target.textContent = label; });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateDates(document), { once: true });
    } else {
      updateDates(document);
    }
    document.addEventListener('shopify:section:load', (event) => updateDates(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
